<template>
	<div>
		<!-- 轮播图  pc端用-->
		<el-carousel class="hidden-sm-and-down">
			<el-carousel-item v-for="item in carouselData" :key="item.id" class="poniter">
				<el-image :src="item.image" fit="cover" @click='goLink(item.link)'></el-image>
				<span class="title" v-if="item.title">{{item.title}}</span>
			</el-carousel-item>
		</el-carousel>
		<!-- 轮播图  移动端用-->
		<van-swipe :autoplay="3000" indicator-color="rgba(208, 212, 219, 0.8)" class="hidden-md-and-up">
			<van-swipe-item v-for="item in carouselData" :key="item.id">
				<el-image :src="item.image" fit="cover" class='yidong-img' @click='goLink(item.link)'></el-image>
				<!-- <span class="title-m" v-if="item.title">{{item.title}}</span> -->
			</van-swipe-item>
		</van-swipe>
		<!-- 千村动态和调查分析 -->
		<div class="middle-wrap" >
			<!-- 千村动态 -->
			<div class="divider-wrap">
				<el-divider>
					<span class='u-font-28 cm hidden-sm-and-down'>千村动态</span>
					<span class='cm hidden-md-and-up u-font-18'>千村动态</span>
				</el-divider>
			</div>
			<div class="u-text-center cm u-relative u-m-t-6 more hidden-sm-and-down" >
				<!-- <span class="u-font-18">Content center</span> -->
				<div class="more-content u-font-18" @click="goContent"><i class="el-icon-right"></i> MORE</div>
			</div>
			<div class="u-text-center cm u-relative more hidden-md-and-up" style="padding-bottom: 10px;">
				<!-- <span class="u-font-12">Content center</span> -->
				<div class="more-content u-font-12" @click="goContent"><i class="el-icon-right"></i> MORE</div>
			</div>
			<el-row class="cont-wrap" @click.native='goDetail(item)' v-for="item in articleList" :key="item.id">
				<el-col :span="8" class="item-wrap u-relative hidden-sm-and-down">
					<el-image :src="item.article_image" fit="cover" lazy class='el-image'></el-image>
					<div class="occur-time">
						<div class="u-font-28">{{item.content_occur_time.substr(-2)}}</div>
						<div>{{item.content_occur_time}}</div>
					</div>
				</el-col>
				<el-col :span="8" class="item-wrap u-relative hidden-md-and-up">
					<el-image :src="item.article_image" fit="cover" lazy></el-image>
					<div class="occur-time">
						<div class="u-font-18">{{item.content_occur_time.substr(-2)}}</div>
						<div class="u-font-12">{{item.content_occur_time}}</div>
					</div>
				</el-col>
				<el-col :span="16" class="cont-right item-wrap hidden-sm-and-down">
					<div class="cm fw u-line-2 u-font-18">{{item.title}}</div>
					<div class="u-m-t-30 u-font-14 cgray u-line-3" v-html="item.detail_info_list" style="line-height: 1.5;">

					</div>
					<div class="u-m-t-24 cgray">
						<van-icon name="clock-o" size="12" color="#7c2326" />
						<span class="u-font-12 u-m-l-4">发布时间: {{moment(item.updated_at).format('YYYY-MM-DD')}}</span>
					</div>
				</el-col>
				<el-col :span="16" class="cont-right item-wrap hidden-md-and-up">
					<div class="cm fw u-line-2 u-font-14">{{item.title}}</div>
					<div class="u-m-t-4 u-font-12 cgray u-line-3" v-html="item.detail_info_list" style="line-height: 1.5;">
				
					</div>
					<div class="cgray">
						<van-icon name="clock-o" class="u-font-12" color="#7c2326" />
						<span class="u-font-12 u-m-l-4">发布时间: {{moment(item.updated_at).format('YYYY-MM-DD')}}</span>
					</div>
				</el-col>
			</el-row>
			<!-- 图表 -->
			<div class="divider-wrap" style="margin-top: 44px;">
				<el-divider>
					<span class='u-font-28 cm hidden-sm-and-down'>调查分析</span>
					<span class='cm hidden-md-and-up u-font-18'>调查分析</span>
				</el-divider>
			</div>
			<!-- <div class="u-text-center cm u-m-t-6">
				<span>Investigation and analysis</span>
			</div> -->
			<el-row>
				<el-col :sm="24" :md="12">
					<div id="echarts1" class="echarts-wrap"></div>
					<div class="u-text-center cm u-font-18 fw hidden-sm-and-down">
						千村调查涉及省份数
					</div>
					<div class="u-text-center cm u-font-12 fw hidden-md-and-up">
						千村调查涉及省份数
					</div>
				</el-col>
				<el-col :sm="24" :md="12">
					<div id="echarts2" class="echarts-wrap"></div>
					<div class="u-text-center cm u-font-18 fw hidden-sm-and-down">
						千村调查受访村、户数
					</div>
					<div class="u-text-center cm u-font-12 fw hidden-md-and-up">
						千村调查受访村、户数
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import chinaJson from '../utils/china.json';
	import base64 from '../utils/base64.json';
	import * as echarts from 'echarts';
	export default {
		name: 'Home',
		components: {},
		data() {
			return {
				carouselData: [],
				articleList: [],
				query: {
					pageNum: 1,
					pageSize: 3, //首页设计图上就展示3个
				},
				province_code: {}, // 所有省对应的code对象
				year_list: '',
			}
		},
		activated() {
			//实例被激活时使用
		},
		async mounted() {
			this.getCarousel()
			this.getArticleList()
			var chartDom1 = document.getElementById('echarts1');
			var myChart1 = echarts.init(chartDom1);
			var chartDom2 = document.getElementById('echarts2');
			var myChart2 = echarts.init(chartDom2);
			var markPointData = []
			var mapsData=[]
			// 获取所有省对应的code
			const province_code = await this.$API.area_code()
			this.province_code = province_code.data
			// 查询年列表下拉数据
			// const res_year = await this.$API.queryIndex({
			// 	query_type: "year"
			// })
			// this.year_list = res_year.years.join(';')
			// 查询省下拉数据
			// let res = await this.$API.queryIndex({
			// 	query_type: "province",
			// 	year_list: this.year_list
			// })
			// res.data = res.data.filter(item => item.province_code)
			let res =await this.$API.province_interviewee()
			res.forEach(item => {
				let arr = chinaJson.features.filter(item2 => this.province_code[item.province_code].indexOf(
					item2.properties.name) > -1)
				markPointData.push({
					// name: "四川移动",
					coord: arr[0].properties.cp,
					symbol: base64.base64, // 标注图片地址路径 只能是image://url 或者base64 不能是本地
					symbolSize: 8,
					symbolOffset: [0, '-100%'],
					itemStyle: {}
					// service: '这个是自定义的字段，不是echarts的配置',
					// url: '这个也是自定义的字段，不是echarts的配置'
				})
				mapsData.push({
					name:arr[0].properties.name,
					value:item.interviewee_user_num
				})
			})
			
			echarts.registerMap('china', chinaJson);
			myChart1.setOption({
				geo: {
					type: 'map',
					map: 'china',
					itemStyle: {
						areaColor: 'rgb(248,248,248)',
						borderColor: 'rgb(215,207,175)',
					},
					label: {
						show: true,
						color: '#777',
						// position: ['50%', '50%'],
						fontSize: 8,
						// align: 'center',
						//  verticalAlign: 'middle',
					},
					emphasis: {
						itemStyle: {
							areaColor: '#7c2326',
							borderColor: '#7c2326',
						},
						label: {
							show: true,
							color: '#fff',
						}
					}
				},
				visualMap: {
				        min:Math.min.apply(Math,mapsData.map(item => { return item.value })),
				        max:Math.max.apply(Math,mapsData.map(item => { return item.value })),
				        text:['最大','最小'],
				        realtime: false,
				        calculable: true,
				        inRange: {
				            color: ['#e0ffff', '#006edd']
				        }
				    },
				
				series: [{
					name: '千村调查涉及省份数',
					type: 'map',
					geoIndex: 0,
					markPoint: { //图表标注。
						label: {
							normal: {
								show: true,
							},
							emphasis: {
								show: true,
							}
						},
						// itemStyle: {
						// 	normal: {
						// 		color: 'rgba(72,150,128,1)'
						// 	}
						// },
						data: markPointData
					},
					 data:mapsData,  //地图数据
				}]
			})
			
			const option2_data=await this.$API.year_interviewee()
			let x_data=[],y_data=[],y_data2=[]
			option2_data.forEach(item=>{
				x_data.push(item.year)
				y_data.push(item.interviewee_user_num)
				y_data2.push(item.interviewee_family_num)
			})
			var option2;
			option2 = {
				 grid: {
				    left:'14%',
				    right:'14%'
				  },
				// 提示框
				tooltip: {
					trigger: 'item',
				},
				// 最上面工具栏
				toolbox: {
					show: false
				},
				// 图例组件
				legend: {
					show: false
				},
				xAxis: [{
					type: 'category',
					data: x_data,
					axisPointer: {
						type: 'shadow'
					}
				}],
				yAxis: [{
						type: 'value',
						name: '受访村数',
						nameTextStyle:{
						            padding:[0,36,0,0],
						        }
						// min: Math.min(...y_data),
						// max: Math.max(...y_data),
						// interval: 50,
						// axisLabel: {
						// 	formatter: '{value} ml'
						// }
					},
					// 第二个y轴是为了画折线,隐藏
					{
						type: 'value',
						name: '受访户数',
						nameTextStyle:{
						            padding:[0,0,0,46],
						        }
					}
				],
				series: [{
						name: '受访村数',
						type: 'bar',
						data: y_data,
						itemStyle: {
							color: "#82add9"
						}
					},
					{
						name: '受访户数',
						type: 'line',
						yAxisIndex: 1,
						data: y_data2,
						lineStyle: {
							color: "#5aa572"
						},
						itemStyle: {
							color: "#5aa572"
						}
					}
				]
			};

			option2 && myChart2.setOption(option2);
			window.onresize = () => {
				myChart1.resize();
				myChart2.resize();
			};
		},
		methods: {
			// 获取轮播图数据
			async getCarousel() {
				const res = await this.$API.carousel()
				this.carouselData = res.data.results
			},
			// 获取轮播图数据
			async getArticleList() {
				const res = await this.$API.articleList(this.query)
				res.data.results.forEach(item => {
					item.detail_info_list = item.detail_info.replace(/<\/?.+?>/g, "").replace(/&nbsp;/g, " ")
				})

				this.articleList = res.data.results
			},
			goLink(link) {
				if (!link) {
					return
				}
				window.location.href = link
			},
			goContent() {
				this.$router.push('/content')
			},
			goDetail(item) {
				localStorage.setItem('article', JSON.stringify(item))
				this.$router.push({
					path: '/detail'
				})
			}
		},
	}
</script>

<style lang="less" scoped>
	.title {
		position: absolute;
		bottom: 40px;
		right: 50%;
		transform: translateX(50%);
		background-color: rgba(0, 0, 0, 0.6);
		padding: 4px 12px;
		color: #fff;
		display: inline-block;
		font-size: 24px;
		width: fit-content;
	}

	.title-m {
		position: absolute;
		bottom: 30px;
		right: 50%;
		transform: translateX(50%);
		background-color: rgba(0, 0, 0, 0.6);
		padding: 4px 20px;
		color: #fff;
		display: inline-block !important;
		font-size: 14px !important;
		width: fit-content;
	}

	.occur-time {
		color: #e1dfdf;
		position: absolute;
		top: 20px;
		left: 16px;
	}

	.el-carousel {
		height: 3.125rem;

		/deep/ .el-carousel__container {
			height: 100% !important;
		}

	}

	.yidong-img {
		height: 4.8rem;
		border-radius: 10px;
		// min-height: 180PX;
	}
	
	.middle-wrap {
		width: 100%;
		margin: 44px auto 0;
		max-width: 1000PX;
		// padding: 0 12PX;
		box-sizing: border-box;
		padding-bottom: 60px;
		.echarts-wrap {
			height: 400px;
			width: 100%;
			min-height: 320PX;
		}

		.divider-wrap {
			width: 70%;
			margin: 0 auto;

			.el-divider__text {
				background-color: #ecf1f4;
			}

			.el-divider {
				background-color: #e7e7e7;
			}
		}

		.more {
			margin-bottom: 45px;

			.more-content {
				position: absolute;
				right: 0;
				bottom: 0;
				cursor: pointer;
			}
		}

		.cont-wrap {
			height: 210px;
			// min-height: 120PX;
			margin-bottom: 10PX;
			border-radius: 10PX;
			overflow: hidden;
			cursor: pointer;

			.item-wrap {
				height: 100%;
				overflow: hidden;
				.el-image:hover{
					transform: scale(1.2);
				}
				.el-image{
					transition-duration: 0.3s;
				}
			}

			.cont-right {
				padding: 18px 10px 0 26px;
				background-color: #fff;
			}
		}
	}
	
</style>
